<template>
  <a-drawer
      :title="`查看导入素材任务进度`"
      :width="`75%`"
      :visible="showTaskPage"
      :mask-closable="true"
      :closable="true"
      :destroy-on-close="true"
      :get-container="false"
      :footer-style="{textAlign: 'center'}"
      :footer="null"
      @close="close"
      @change="onVisibleChange"
  >

      <div class="search-wrapper">
          <div class="title"><a-icon type="search" /> 数据筛选</div>
          <a-divider></a-divider>
          <a-space>
            <a-input allow-clear placeholder="素材名称" v-model="queryParam.name" />
            <a-input allow-clear placeholder="素材地址" v-model="queryParam.url" />
            <a-range-picker
              v-model="queryParam.date"
              :placeholder="['导入开始日期', '导入结束日期']"/>
            <a-button type="primary" @click="search">查询</a-button>
            <a-button @click="resetSearch">重置</a-button>
          </a-space>
      </div>

      <div class="task-progress">
        <a-card size="small" :bordered="false" style="margin-bottom: 16px">
          <div class="task-progress-header">
            <strong>任务进度统计（24小时内，总平台任务）</strong>
              <span class="task-progress-time">
                <a-icon type="reload" spin style="margin-right: 4px" />
                数据更新时间：{{ lastUpdateTime }} （每分钟自动刷新）
              </span>
          </div>
          <a-divider style="margin: 8px 0" />

          <a-row :gutter="24">
            <!-- 下载任务 -->
            <a-col :span="8">
              <div class="task-block">
                <h4>下载任务</h4>
                <p>
                  总数量：<a-tag color="blue">{{ taskProgress.download_stats.total }}</a-tag>
                  已完成：<a-tag color="green">{{ taskProgress.download_stats.completed }}</a-tag>
                  失败：<a-tag color="volcano">{{ taskProgress.download_stats.failed }}</a-tag>
                  执行中：<a-tag color="orange">{{ taskProgress.download_stats.running }}</a-tag>
                  未执行：<a-tag color="red">{{ taskProgress.download_stats.pending }}</a-tag>
                </p>
                <a-progress
                  :percent="downloadProgressPercent"
                  :stroke-color="{
                    '0%': '#108ee9',
                    '100%': '#87d068'
                  }"
                  show-info
                />
              </div>
            </a-col>

            <!-- 转码任务 -->
            <a-col :span="8">
              <div class="task-block">
                <h4>转码任务</h4>
                <p>
                  总数量：<a-tag color="blue">{{ taskProgress.transcode_stats.total }}</a-tag>
                  已完成：<a-tag color="green">{{ taskProgress.transcode_stats.completed }}</a-tag>
                  失败：<a-tag color="volcano">{{ taskProgress.transcode_stats.failed }}</a-tag>
                  执行中：<a-tag color="orange">{{ taskProgress.transcode_stats.running }}</a-tag>
                  未执行：<a-tag color="red">{{ taskProgress.transcode_stats.pending }}</a-tag>
                </p>
                <a-progress
                  :percent="transcodeProgressPercent"
                  :stroke-color="{
                    '0%': '#108ee9',
                    '100%': '#87d068'
                  }"
                  show-info
                />
              </div>
            </a-col>

            <!-- 同步任务 -->
            <a-col :span="8">
              <div class="task-block">
                <h4>同步任务(巨量)</h4>
                <p>
                  总数量：<a-tag color="blue">{{ taskProgress.sync_stats.total }}</a-tag>
                  已完成：<a-tag color="green">{{ taskProgress.sync_stats.completed }}</a-tag>
                  失败：<a-tag color="volcano">{{ taskProgress.sync_stats.failed }}</a-tag>
                  执行中：<a-tag color="orange">{{ taskProgress.sync_stats.running }}</a-tag>
                  未执行：<a-tag color="red">{{ taskProgress.sync_stats.pending }}</a-tag>
                </p>
                <a-progress
                  :percent="syncProgressPercent"
                  :stroke-color="{
                    '0%': '#108ee9',
                    '100%': '#87d068'
                  }"
                  show-info
                />
              </div>
            </a-col>

            <!-- 同步任务 -->
            <a-col :span="8">
              <div class="task-block">
                <h4>同步任务(巨量组织)</h4>
                <p>
                  总数量：<a-tag color="blue">{{ taskProgress.sync_organize_stats.total }}</a-tag>
                  已完成：<a-tag color="green">{{ taskProgress.sync_organize_stats.completed }}</a-tag>
                  失败：<a-tag color="volcano">{{ taskProgress.sync_organize_stats.failed }}</a-tag>
                  执行中：<a-tag color="orange">{{ taskProgress.sync_organize_stats.running }}</a-tag>
                  未执行：<a-tag color="red">{{ taskProgress.sync_organize_stats.pending }}</a-tag>
                </p>
                <a-progress
                  :percent="syncOrganizeProgressPercent"
                  :stroke-color="{
                    '0%': '#108ee9',
                    '100%': '#87d068'
                  }"
                  show-info
                />
              </div>
            </a-col>

            <!-- 同步任务：快手-MAPI（sync_material_type 为 1/2 或空） -->
            <a-col :span="8">
              <div class="task-block">
                <h4>同步任务(快手-MAPI)</h4>
                <p>
                  总数量：<a-tag color="blue">{{ taskProgress.sync_ks_stats.total }}</a-tag>
                  已完成：<a-tag color="green">{{ taskProgress.sync_ks_stats.completed }}</a-tag>
                  失败：<a-tag color="volcano">{{ taskProgress.sync_ks_stats.failed }}</a-tag>
                  执行中：<a-tag color="orange">{{ taskProgress.sync_ks_stats.running }}</a-tag>
                  未执行：<a-tag color="red">{{ taskProgress.sync_ks_stats.pending }}</a-tag>
                </p>
                <a-progress
                  :percent="syncKsProgressPercent"
                  :stroke-color="{
                    '0%': '#108ee9',
                    '100%': '#87d068'
                  }"
                  show-info
                />
              </div>
            </a-col>

            <!-- 同步任务：快手-本地上传（sync_material_type = 3） -->
            <a-col :span="8">
              <div class="task-block">
                <h4>同步任务(快手-本地上传)</h4>
                <p>
                  总数量：<a-tag color="blue">{{ taskProgress.sync_ks_local_stats.total }}</a-tag>
                  已完成：<a-tag color="green">{{ taskProgress.sync_ks_local_stats.completed }}</a-tag>
                  失败：<a-tag color="volcano">{{ taskProgress.sync_ks_local_stats.failed }}</a-tag>
                  执行中：<a-tag color="orange">{{ taskProgress.sync_ks_local_stats.running }}</a-tag>
                  未执行：<a-tag color="red">{{ taskProgress.sync_ks_local_stats.pending }}</a-tag>
                </p>
                <a-progress
                  :percent="syncKsLocalProgressPercent"
                  :stroke-color="{
                    '0%': '#108ee9',
                    '100%': '#87d068'
                  }"
                  show-info
                />
              </div>
            </a-col>
          </a-row>
        </a-card>
      </div>

      <vxe-grid
          class="table-scrollbar"
          v-bind="tableGrid"
          @page-change="handlePageChange"
          @sort-change="handleSortChange"
          @checkbox-change="handleRowChange"
          @checkbox-all="handleRowChange"
        >

        <template #playlet_name="{ row }">
          <span>{{ row.params.playlet_name }}</span>
        </template>

        <template #result="{ row }">
          <div class="result">
            <span>{{ row.completed }}</span>/{{ row.total }}
          </div>
        </template>

        <template #status="{ row }">
            <a-tag :color="row.status|statusColor">{{ $helper.getItemName(taskStatus, row.status) }}</a-tag>
        </template>

        <template #toolbar_buttons>
        </template>

        <template #actions="{ row }">
          <div class="actions">
            <template v-if="accessTo('index')">
              <a href="javascript:;" @click="taskRecord(row)" v-if="accessTo('index')">任务记录</a>
            </template>
            <template v-else>-</template>
          </div>
        </template>
      </vxe-grid>

  </a-drawer>
</template>

<style lang="less" scoped>
@import 'Task';
</style>

<script>
import Task from './Task'

export default Task
</script>
